import angular from 'angular';

class Browser {
	constructor($window) {
		var ua = $window.navigator.userAgent;
		var temp;
		var matches = ua.match(/(opr|chrome|safari|firefox|msie|trident(?=\/))\/?\s*([\d\.]+)/i) || [];
		if (/trident/i.test(matches[1])) {
			temp = /\brv[ :]+(\d+(\.\d+)?)/g.exec(ua) || [];
			return {
				name: 'Internet Explorer',
				version: (temp[1] || '')
			};
		}
		if ((temp = ua.match(/version\/([\.\d]+)/i)) !== null) {
			matches[2] = temp[1];
		}
		matches = matches[2] ? [matches[1], matches[2]] : [navigator.appName, navigator.appVersion];
		// Limit to major version
		matches[1] = /^\d([^.]+)?/.exec(matches[1])[0] || matches[1];
		// Rewrite IE match name
		matches[0] = (matches[0] === 'MSIE') ? 'Internet Explorer' : matches[0];

		this.name = matches[0];
		this.version = matches[1];
		this.isMobile = ua.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i) ? true : false;
	}
}
Browser.$inject = ['$window'];

export default angular.module('services.browser', [])
	.service('Browser', Browser)
	.name;



// WEBPACK FOOTER //
// ./project/services/browser.js